import {TranslatableString} from '../../../../models/TranslatableString';

export class Field {
  value: TranslatableString;
  isSelected: boolean;
  
  constructor(val: TranslatableString, isSelected: boolean = true) {
    this.value = val;
    this.isSelected = isSelected;
  }
}
